import { create } from "zustand";

interface ActivityTrayState {
    isOpen: boolean;
    open: () => void;
    close: () => void;
    toggle: () => void;
}

/**
 * Lets external code (e.g. toast notifications) programmatically open the
 * activity tray, which otherwise lives inside a Popover with its own state.
 */
export const useActivityTrayStore = create<ActivityTrayState>((set) => ({
    isOpen: false,
    open: () => set({ isOpen: true }),
    close: () => set({ isOpen: false }),
    toggle: () => set((s) => ({ isOpen: !s.isOpen }))
}));
